export default __webpack_public_path__ + "e922ec8b9409c155bf665438bf310ab1.png";